import { Box } from "@mui/material";
import { useNutritionFlags } from "../../hooks/useNutritionFlags";
import { AskTeamworksWidget } from "./AskTeamworksWidget";
import { MenuAnalyticsDashboard } from "./Dashboard";
import { MenuAnalyticsUnavailable } from "./states";

/**
 * Route entry point for the Menu Order Analytics dashboard (NUT-2024).
 *
 * Gated on the `menuAnalyticsDashboardEnabled` LaunchDarkly flag. The Kitchen nav
 * tab is only shown when the flag is on, but the route is always registered, so
 * direct navigation while the flag is off renders a graceful unavailable state
 * rather than a blank screen.
 */
export const MenuAnalytics = () => {
  const { menuAnalyticsDashboardEnabled, isAskTeamworksEnabled } = useNutritionFlags();

  if (!menuAnalyticsDashboardEnabled) {
    return <MenuAnalyticsUnavailable />;
  }

  return (
    // The dashboard gets its own scroll region so the Ask Teamworks bottom bar
    // stays pinned below it instead of scrolling away with a tall table.
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
      {/* isolation keeps any z-index inside the dashboard (e.g. sticky table headers) beneath the fullscreen chat. */}
      <Box sx={{ flex: 1, overflow: "auto", minHeight: 0, isolation: "isolate" }}>
        <MenuAnalyticsDashboard />
      </Box>
      {isAskTeamworksEnabled && <AskTeamworksWidget />}
    </Box>
  );
};
